var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  attrs: { disabled: !_vm.isValid },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
              _c(
                "w-toolbar-select",
                {
                  attrs: {
                    "hide-arrow": "",
                    items: _vm.dropdownItems,
                    right: "",
                  },
                  on: {
                    click: function ($event) {
                      return $event()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { attrs: { "no-margin": "", "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? [
                    _c(
                      "w-dropdown",
                      {
                        staticClass: "mr",
                        attrs: {
                          "trigger-class": "cancel",
                          right: "",
                          items: _vm.dropdownItems,
                        },
                        on: {
                          click: function ($event) {
                            return $event()
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "bars" } })],
                      1
                    ),
                    _c(
                      "w-button",
                      {
                        attrs: { disabled: !_vm.isValid, icon: "check" },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "transition",
            { attrs: { name: "fast-fade" } },
            [
              _vm.config && _vm.userSaleConfig
                ? _c(
                    "w-scroll-view",
                    { attrs: { tag: "w-container" } },
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-sale-type-edit-general", {
                                attrs: {
                                  "sale-type": _vm.saleType,
                                  config: _vm.config,
                                  "user-config": _vm.userSaleConfig,
                                  "electron-default-download-location":
                                    _vm.electronDefaultDownloadLocation,
                                },
                                on: {
                                  "electron-default-download-location":
                                    function ($event) {
                                      _vm.electronDefaultDownloadLocation =
                                        $event
                                    },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("app-sale-type-edit-texts", {
                                attrs: { config: _vm.config },
                              }),
                              _c("app-sale-type-edit-mail-settings", {
                                attrs: {
                                  config: _vm.config,
                                  "user-config": _vm.userSaleConfig,
                                },
                                on: {
                                  valid: function ($event) {
                                    _vm.generalValid = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c(
                                "app-edit-default-import-sale-row-description-template",
                                {
                                  attrs: {
                                    title: _vm.$ct(
                                      "sale-import-description-template"
                                    ),
                                  },
                                  model: {
                                    value:
                                      _vm.config
                                        .SaleImportRowDescriptionTemplate,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.config,
                                        "SaleImportRowDescriptionTemplate",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "config.SaleImportRowDescriptionTemplate",
                                  },
                                }
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-transition-slide-height",
                        [
                          _vm.config.ComputeStock
                            ? _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c(
                                        "app-edit-per-document-stock-settings",
                                        { attrs: { config: _vm.config } }
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.hasCalendarModule
                        ? _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("app-sale-type-calendar-settings", {
                                    attrs: { "user-conf": _vm.userSaleConfig },
                                  }),
                                  _c("app-sale-type-calendar-hover-settings", {
                                    attrs: { "user-conf": _vm.userSaleConfig },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm.saleType && _vm.editTranslationsModal
        ? _c(
            "w-modal",
            {
              model: {
                value: _vm.editTranslationsModal,
                callback: function ($$v) {
                  _vm.editTranslationsModal = $$v
                },
                expression: "editTranslationsModal",
              },
            },
            [
              _c("app-translation-edit-modal", {
                attrs: {
                  value: _vm.saleType.Name,
                  textarea: true,
                  title: _vm.$ct("edit-sale-type-translations"),
                },
                on: {
                  input: function ($event) {
                    return _vm.onNewTypeName($event)
                  },
                  close: function ($event) {
                    _vm.editTranslationsModal = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.saleType && _vm.renameModal
        ? _c("app-sale-type-edit-name", {
            attrs: { "sale-type": _vm.saleType },
            on: {
              close: function ($event) {
                _vm.renameModal = false
              },
              input: function ($event) {
                _vm.saleType = $event
              },
            },
          })
        : _vm._e(),
      _vm.askNextNumberModalData.isOpen
        ? _c("app-ask-next-number", {
            on: {
              success: function ($event) {
                return _vm.askNextNumberModalData.onSuccess($event)
              },
              failure: function ($event) {
                return _vm.askNextNumberModalData.onFailure($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }